// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared Top Wins amount (small + featured cards). Themed by the parent through
 * custom properties (set on any ancestor, inherited here):
 *   --tw-amount-clip     row/viewport height = swap translation distance
 *   --tw-amount-size     amount font size (before any shrink-to-fit scaling)
 *   --tw-amount-color    amount colour
 *   --tw-amount-justify  horizontal alignment of the line (flex-start | center)
 *   --tw-amount-origin   transform-origin for the shrink-to-fit scale
 *                        (left center for left-aligned, center center otherwise)
 *   --tw-amount-offset-y vertical nudge of the whole amount block
 *   --tw-amount-inset    px reserved per side when shrinking to fit, so a
 *                        scaled amount keeps a margin from the card edges
 */
.cRNwDEdlJj8UCXygzABD {
  position: relative;
  width: 100%;
  height: var(--tw-amount-clip, 30px);
  transform: translateY(var(--tw-amount-offset-y, 0px));
  /* Visible by default so a single line's glyphs can paint freely; clipped only
     for the reel, where hiding the inactive stacked row is required. */
  overflow: visible;
}
.cRNwDEdlJj8UCXygzABD:has(.ZQ26FxJP22LpCPusLkV0) {
  overflow: hidden;
}
.ZQ26FxJP22LpCPusLkV0 {
  display: flex;
  flex-direction: column;
  /* Full width so the rows span the parent (alignment then works) — a column
     flex container would otherwise shrink-wrap to its content width. */
  width: 100%;
  position: relative;
}
/* The swap is two transitions, toggled by TopWinAmount (hold 2.7s, 0.6s down,
   hold 2.4s, 0.3s back: a 6s cycle). Not an infinite keyframe animation:
   Chromium services those every frame, holds included. On transform, with the
   transition on only while a move runs (data-moving): the compositor slides the
   reel and Chrome gives it a layer for the move alone, none during the holds. On
   top, every frame of a move was a main-thread layout and a repaint of the whole
   viewport. A breakpoint change of --tw-amount-clip during a hold snaps the reel,
   as the animation did. */
.ZQ26FxJP22LpCPusLkV0[data-swapped] {
  transform: translateY(calc(-1 * var(--tw-amount-clip, 30px)));
}
.ZQ26FxJP22LpCPusLkV0[data-moving] {
  transition: transform 0.3s ease-in-out;
}
.ZQ26FxJP22LpCPusLkV0[data-moving][data-swapped] {
  transition-duration: 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .ZQ26FxJP22LpCPusLkV0[data-moving],
  .ZQ26FxJP22LpCPusLkV0[data-moving][data-swapped] {
    transition: none;
  }
}
/* One amount line: a fixed-height (= clip) flex row so the reel translates by a
   constant distance and the text is vertically centred. overflow:hidden is only
   a guard — the JS shrink-to-fit keeps the text within the row. */
.IrIk2VCBli0F2omaVA7w {
  display: flex;
  align-items: center;
  justify-content: var(--tw-amount-justify, flex-start);
  flex: 0 0 var(--tw-amount-clip, 30px);
  height: var(--tw-amount-clip, 30px);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  overflow: hidden;
}
/* The measured/scaled text. inline-block + nowrap so scrollWidth reflects the
   natural (unscaled) width the fit logic divides against. */
.t7NaUNWDdQ0icK3COVrY {
  display: inline-block;
  white-space: nowrap;
  transform-origin: var(--tw-amount-origin, left center);
  font-family: var(--font-family-secondary);
  font-weight: 800;
  color: var(--tw-amount-color, #f9f9f9);
  font-size: var(--tw-amount-size, 30px);
  line-height: 1;
}
.cG_QFt2gRsVnWoMtlZIc {
  font-size: 1em;
}
.XswLSVEl_5VmUDIoMUkE {
  font-size: 0.6em;
  margin-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/features/topWins/components/TopWinAmount/TopWinAmount.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;AACF;EACE,kBAAkB;EAClB,WAAW;EACX,mCAAmC;EACnC,qDAAqD;EACrD;uEACqE;EACrE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB;uEACqE;EACrE,WAAW;EACX,kBAAkB;AACpB;AACA;;;;;;;0BAO0B;AAC1B;EACE,6DAA6D;AAC/D;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;;IAEE,gBAAgB;EAClB;AACF;AACA;;kEAEkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;4DAC4D;AAC5D;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sDAAsD;EACtD,yCAAyC;EACzC,gBAAgB;EAChB,sCAAsC;EACtC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/*\n * Shared Top Wins amount (small + featured cards). Themed by the parent through\n * custom properties (set on any ancestor, inherited here):\n *   --tw-amount-clip     row/viewport height = swap translation distance\n *   --tw-amount-size     amount font size (before any shrink-to-fit scaling)\n *   --tw-amount-color    amount colour\n *   --tw-amount-justify  horizontal alignment of the line (flex-start | center)\n *   --tw-amount-origin   transform-origin for the shrink-to-fit scale\n *                        (left center for left-aligned, center center otherwise)\n *   --tw-amount-offset-y vertical nudge of the whole amount block\n *   --tw-amount-inset    px reserved per side when shrinking to fit, so a\n *                        scaled amount keeps a margin from the card edges\n */\n.wrapper {\n  position: relative;\n  width: 100%;\n  height: var(--tw-amount-clip, 30px);\n  transform: translateY(var(--tw-amount-offset-y, 0px));\n  /* Visible by default so a single line's glyphs can paint freely; clipped only\n     for the reel, where hiding the inactive stacked row is required. */\n  overflow: visible;\n}\n.wrapper:has(.reel) {\n  overflow: hidden;\n}\n.reel {\n  display: flex;\n  flex-direction: column;\n  /* Full width so the rows span the parent (alignment then works) — a column\n     flex container would otherwise shrink-wrap to its content width. */\n  width: 100%;\n  position: relative;\n}\n/* The swap is two transitions, toggled by TopWinAmount (hold 2.7s, 0.6s down,\n   hold 2.4s, 0.3s back: a 6s cycle). Not an infinite keyframe animation:\n   Chromium services those every frame, holds included. On transform, with the\n   transition on only while a move runs (data-moving): the compositor slides the\n   reel and Chrome gives it a layer for the move alone, none during the holds. On\n   top, every frame of a move was a main-thread layout and a repaint of the whole\n   viewport. A breakpoint change of --tw-amount-clip during a hold snaps the reel,\n   as the animation did. */\n.reel[data-swapped] {\n  transform: translateY(calc(-1 * var(--tw-amount-clip, 30px)));\n}\n.reel[data-moving] {\n  transition: transform 0.3s ease-in-out;\n}\n.reel[data-moving][data-swapped] {\n  transition-duration: 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .reel[data-moving],\n  .reel[data-moving][data-swapped] {\n    transition: none;\n  }\n}\n/* One amount line: a fixed-height (= clip) flex row so the reel translates by a\n   constant distance and the text is vertically centred. overflow:hidden is only\n   a guard — the JS shrink-to-fit keeps the text within the row. */\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: var(--tw-amount-justify, flex-start);\n  flex: 0 0 var(--tw-amount-clip, 30px);\n  height: var(--tw-amount-clip, 30px);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n}\n/* The measured/scaled text. inline-block + nowrap so scrollWidth reflects the\n   natural (unscaled) width the fit logic divides against. */\n.fit {\n  display: inline-block;\n  white-space: nowrap;\n  transform-origin: var(--tw-amount-origin, left center);\n  font-family: var(--font-family-secondary);\n  font-weight: 800;\n  color: var(--tw-amount-color, #f9f9f9);\n  font-size: var(--tw-amount-size, 30px);\n  line-height: 1;\n}\n.major {\n  font-size: 1em;\n}\n.currency {\n  font-size: 0.6em;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `cRNwDEdlJj8UCXygzABD`,
	"reel": `ZQ26FxJP22LpCPusLkV0`,
	"row": `IrIk2VCBli0F2omaVA7w`,
	"fit": `t7NaUNWDdQ0icK3COVrY`,
	"major": `cG_QFt2gRsVnWoMtlZIc`,
	"currency": `XswLSVEl_5VmUDIoMUkE`
};
export default ___CSS_LOADER_EXPORT___;
